import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AllShipNamesService {
  busSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetAllShipNames(): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const AllShipNamesInfo: JSON = <JSON>(<unknown>{});
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetAllShipNames',
      JSON.stringify(AllShipNamesInfo),
      { headers: headers }
    );
  }
}
